import type {
  PartialMetadataMap,
  XingletConfig,
} from '@xing-com/crate-core-assets';

export type Contributes = Exclude<XingletConfig['contributes'], undefined>;
export type EntryPointConfig = Exclude<Contributes['entryPoint'], undefined>;
export type Site = EntryPointConfig['site'];

export function getEntryPointConfig(
  metadataMap: PartialMetadataMap,
  entryPoint: string
): EntryPointConfig {
  const config = metadataMap[entryPoint]?.contributes?.entryPoint;

  if (!config) {
    throw new Error(
      `Xinglet "${entryPoint}" is missing the required configuration for entry points`
    );
  }

  return config;
}

export { XingletConfig };
